import { useEffect } from 'react'

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: {
          portalId: string
          formId: string
          region?: string
          target?: string
        }) => void
      }
    }
  }
}

export default function FormContactCompany() {
  useEffect(() => {
    const scriptSrc = '//js.hsforms.net/forms/embed/v2.js'
    const existingScript = document.querySelector<HTMLScriptElement>(
      `script[src="${scriptSrc}"]`,
    )

    const createForm = () => {
      if (!window.hbspt || !window.hbspt.forms) return

      window.hbspt.forms.create({
        portalId: '2761658',
        formId: '0d5ffc2c-9e85-43dd-ae32-8e51f3e56ded',
        region: 'na1',
        target: '#hubspot-form-company',
      })
    }

    if (existingScript) {
      // Script ya cargado en la página
      createForm()
    } else {
      // Cargar el script de HubSpot
      const script = document.createElement('script')
      script.src = scriptSrc
      script.type = 'text/javascript'
      script.charset = 'utf-8'
      script.onload = createForm
      document.body.appendChild(script)
    }
  }, [])

  return (
    <div className="h-full flex flex-col justify-between">
      {/* contenedor donde HubSpot inyectará el formulario */}
      <div id="hubspot-form-company" />
    </div>
  )
}
